import React from "react";
import classNames from "classnames";
import { currencyFormatter } from "@common/helpers/currency";
import styles from "./JournalEntryCells.module.scss";

interface AmountDiffCellProps {
    oldAmount?: number | null;
    newAmount: number | null;
    hasChanges?: boolean;
    isAdded?: boolean;
    isRemoved?: boolean;
}

const formatAmount = (val: number | null) =>
    val != null ? currencyFormatter.format(val) : "";

export const AmountDiffCell: React.FC<AmountDiffCellProps> = ({
    oldAmount,
    newAmount,
    hasChanges,
    isAdded,
    isRemoved,
}) => {
    if (isRemoved) {
        return (
            <span className={classNames(styles.newValue, styles.removedText)}>
                {formatAmount(newAmount)}
            </span>
        );
    }

    if (isAdded) {
        return (
            <span className={styles.addedText}>{formatAmount(newAmount)}</span>
        );
    }

    if (!hasChanges || oldAmount === undefined || oldAmount === newAmount) {
        return <span>{formatAmount(newAmount)}</span>;
    }

    return (
        <div className={styles.diffContainer}>
            <span className={styles.oldValue}>{formatAmount(oldAmount)}</span>
            <span className={styles.newValue}>{formatAmount(newAmount)}</span>
        </div>
    );
};
